import LayoutManager from "./LayoutManager";

class ListLayoutManager extends LayoutManager {
    constructor(itemGrid: JQuery) {
        super(itemGrid)
    }

    addItem(itemView: JQuery) {
        this.itemGrid.append(itemView)
    }

    layoutItem(itemView: JQuery, position: number) {
        itemView.css('order', position)
    }

    removeItem(itemView: JQuery) {
        itemView.remove()
    }

    onPreUpdate() {
        this.itemGrid.css('min-height', `${this.itemGrid.height()}px`)
    }

    onPostUpdate() {
        this.itemGrid.css('min-height', '')
    }
}

export default ListLayoutManager